(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const prepared = new WeakSet();

  const loadVideo = (video) => {
    if (video.dataset.roseEditorialLoaded === 'true') return;

    video.querySelectorAll('source[data-src]').forEach((source) => {
      source.src = source.dataset.src;
      source.removeAttribute('data-src');
    });
    video.dataset.roseEditorialLoaded = 'true';
    video.load();

    if (!reducedMotion.matches) {
      const playPromise = video.play();
      if (playPromise) playPromise.catch(() => {});
    }
  };

  const prepare = (root = document) => {
    root.querySelectorAll('[data-rose-editorial-film]').forEach((film) => {
      if (prepared.has(film)) return;
      prepared.add(film);

      const video = film.querySelector('[data-rose-editorial-video]');
      if (!video) return;

      if (reducedMotion.matches) {
        video.pause();
        return;
      }

      if (film.dataset.loadPriority === 'eager') {
        loadVideo(video);
        return;
      }

      if (!('IntersectionObserver' in window)) {
        loadVideo(video);
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          loadVideo(video);
          observer.disconnect();
        },
        { rootMargin: '360px 0px' }
      );
      observer.observe(film);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => prepare(), { once: true });
  } else {
    prepare();
  }

  document.addEventListener('shopify:section:load', (event) => prepare(event.target));
  reducedMotion.addEventListener('change', () => {
    document.querySelectorAll('[data-rose-editorial-video]').forEach((video) => {
      if (reducedMotion.matches) {
        video.pause();
      } else if (video.dataset.roseEditorialLoaded === 'true') {
        const playPromise = video.play();
        if (playPromise) playPromise.catch(() => {});
      }
    });
  });
})();
